import React, { Component } from 'react';
import { Toast, ToastBody, Button, Collapse, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import Loader from '../Loader.js';
import ConsoleHelper from '../../ConsoleHelper.js';
import ExportDeviceSettingsMobileStarter from './ExportDeviceSettingsMobileStarter.js';
import MyResource from '../../MyResource.js';
import authHeaders from '../../authHeaders.js';

class ExportDeviceSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      farm_id: "",
      IsDeviceLoaded: true,
      anchoraccordion: [true, false, false, false], // this is length of device_details array
      disabled: false,
      isButtonLoading: false,
      devices: [],

      errorMessageToast: '',
      isOpenToast: false,
      issuccess: false,

      lblExplblmsg083: "Update Successfully",                      //Update Successfully
      lblExplblmsg084: "Failed",                      //Failed

      lblExplblmsg085: "gStart",                      //gStart
      lblExplblmsg086: "Device Sync Pending - Save settings once device comes online and wait for 20 seconds",                      //Device Sync Pending - Save settings once device comes online and wait for 20 seconds
      lblExplblmsg087: "Synced",                      //Synced

    }
  }

  componentDidMount = () => {
    // Embedded (rendered inside a dashboard tile): show just the passed device's
    // settings; no own list load, no fetch.
    if (this.props.embeddedDevice) {
      this.setState({
        devices: [this.props.embeddedDevice],
        anchoraccordion: [true],
        farm_id: this.props.selected_farm ? this.props.selected_farm.farm_id : '',
        IsDeviceLoaded: false,
      });
      return;
    }
    this.setState({
      farm_id: this.props.selected_farm.farm_id,
      IsDeviceLoaded: true,
    })
    this.fetchDeviceDetails(this.props.selected_farm.farm_id);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.embeddedDevice) {
      return; // embedded: settings come from the passed device, no reload on prop change
    }
    if (this.props.selected_farm === null || this.props.selected_farm === undefined) {
      return;
    }
    if (prevProps.selected_farm.farm_id !== this.props.selected_farm.farm_id) {
      this.setState({
        farm_id: this.props.selected_farm.farm_id,
        IsDeviceLoaded: true
      });
      this.fetchDeviceDetails(this.props.selected_farm.farm_id);
    }
    else if (prevProps.random_string !== this.props.random_string) {
      this.setState({
        farm_id: this.props.selected_farm.farm_id,
        IsDeviceLoaded: true,
        devices: []
      })
      this.fetchDeviceDetails(this.props.selected_farm.farm_id);
    }
  }


  toggleToast = () => {
    // ConsoleHelper("inside toggle")
    this.setState({ isOpenToast: false })
  }

  handleToast = () => {
    setTimeout(this.hideToast, 3000);
  }

  hideToast = () => {
    //this.refs.toastDiv.style.display = 'none';
    this.toggleToast();
  }

  fetchDeviceDetails = (localDataFarmId) => {
    if (this.props.embeddedDevice) {
      return; // embedded: no full-list fetch (post-save reload becomes a safe no-op)
    }
    if (!this.props.uid) {
      return;
    }
    this.setState({
      IsDeviceLoaded: true,
    });

    let sentData = {
      method: 'GET',
      headers: authHeaders(),
    };

    fetch(process.env.REACT_APP_URL + "/fm_export_device_config?uid=" + this.props.uid + "&farm_id=" + localDataFarmId, sentData)
      .then(res => res.json())
      .then(details => {
        const filteredDetails = details.filter(
          (device) => device.exp_device_type === 53 || device.exp_device_type === 72
        );

        this.setState((prevState) => {
          const updatedAnchorAccordion = filteredDetails.map((_, index) =>
            prevState.anchoraccordion[index] !== undefined
              ? prevState.anchoraccordion[index]
              : false
          );

          return {
            devices: filteredDetails,
            anchoraccordion: updatedAnchorAccordion,
            IsDeviceLoaded: false,
          };
        });

      },
        (error) => {
          this.setState({ IsError: true });
        });
  };




  toggleAnchorAccordion = (tab) => {
    this.setState(prevState => {
      const anchoraccordion = prevState.anchoraccordion.map((x, index) => tab === index ? !x : false);
      return { anchoraccordion };
    });
  }



  btnSubmit = (index) => {
    var devices = this.state.devices;

    if (devices[index].config) {

      const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

      days.forEach(day => {
        if (devices[index].config.schedule[day].cycle_gap_minute < 1) {
          devices[index].config.schedule[day].cycle_gap_minute = 1;
          devices[index].config.schedule[day].cycle_gap = 60;
        }
      });

      devices[index].config.board = devices[index].bundle_part_code;

      let sentData = {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({
          config: devices[index].config,
          uid: this.props.uid,
          farm_id: this.state.farm_id,
          exp_device_mac_id: devices[index].exp_device_mac_id
        })
      };
      // console.log(devices[index].config);
      // return;

      this.setState({ isButtonLoading: true })
      fetch(process.env.REACT_APP_URL + "/fm_export_device_config_edit", sentData)
        .then(res => res.json())
        .then(details => {
          //console.log(details)
          this.setState({ isButtonLoading: false })
          if (details.code === 200) {
            this.setState({
              isOpenToast: true,
              issuccess: true,
              errorMessageToast: this.state.lblExplblmsg083,
            })
            this.handleToast()
            fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/send_config_export", {
              method: "POST", body: JSON.stringify({
                config: devices[index].config,
                exp_device_mac_id: devices[index].exp_device_mac_id,
                farm_id: this.state.farm_id,
                uid: this.props.uid,
              })
            })
              .then(res => res.json())
              .then(details => { });
            this.setState({
              IsDeviceLoaded: true
            });
            this.fetchDeviceDetails(this.state.farm_id);
            // setTimeout(() => {
            //   window.location.reload(); // Reload the page after 3 seconds
            // }, 3000); // 3000 milliseconds = 3 seconds


          }
          else {
            this.setState({
              isOpenToast: true,
              issuccess: false,
              errorMessageToast: this.state.lblExplblmsg084,
            })
            this.handleToast()
          }
          this.setState({
            disabled: false
          })
        })
    }
  }

  handleCheckboxChangeforce_immediate = (isChecked, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config) {
      devices[index].config.force_immediate = isChecked;
    }
    this.setState({
      devices: devices
    })
  }

  handleValveBrand = (event, index) => {
    var devices = this.state.devices;
  
    if (devices[index]?.config?.settings) {
      const selectedValue = event.target.value;
  
      // Check if the value is not empty
      if (selectedValue !== "") {
        devices[index].config.settings.valve_brand = parseInt(selectedValue);
  
        if (selectedValue == 1) {
          devices[index].config.settings.latch_valve_delay = 50;
          devices[index].config.settings.latch_valve_pulses = 2;
          devices[index].config.settings.latch_valve_pulses_gap = 500;
        } else {
          delete devices[index].config.settings.latch_valve_delay;
          delete devices[index].config.settings.latch_valve_pulses;
          delete devices[index].config.settings.latch_valve_pulses_gap;
        }
      } else {
        devices[index].config.settings.valve_brand = "";
        delete devices[index].config.settings.latch_valve_delay;
        delete devices[index].config.settings.latch_valve_pulses;
        delete devices[index].config.settings.latch_valve_pulses_gap;
      }
    }
  
    this.setState({
      devices: devices
    });
  };
  

  handleMotorType = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.pump_type = parseInt(event.target.value);
      if (event.target.value == 3) {
        devices[index].config.settings.start_delay = 0;
        devices[index].config.settings.stop_delay = 0;
      }
      else if (event.target.value == 1) {
        devices[index].config.settings.stop_delay = 0;
      }
      else if (event.target.value == 2) {

      }
      else if (event.target.value == "") {
        devices[index].config.settings.start_delay = 0;
        devices[index].config.settings.stop_delay = 0;
      }
      else {
        devices[index].config.settings.start_delay = 0;
        devices[index].config.settings.stop_delay = 0;
        devices[index].config.settings.sensing[1].l = 0;
        devices[index].config.settings.sensing[1].h = 0;
        devices[index].config.settings.sensing[2].l = 0;
        devices[index].config.settings.sensing[2].h = 0;
      }
    } else {
      devices[index].config = {
        "force_immediate": 0,
        "automation": 1,
        "board": "Z7",
        "settings": {
          "timezone": 5.5,
          "sensing": [
            {
              "id": 1,
              "da": 2,
              "ra": 8,
              "rt": 1,
              "dt": 2,
              "l": 0,
              "h": 0,
              "active_only": false
            },
            {
              "id": 2,
              "da": 2,
              "ra": 10,
              "rt": 1,
              "dt": 2,
              "l": 0,
              "h": 0,
              "active_only": false
            },
            {
              "id": 3,
              "da": 2,
              "ra": 12,
              "rt": 1,
              "dt": 2,
              "l": 0,
              "h": 0,
              "active_only": false
            },
            {
              "id": 4,
              "da": 2,
              "ra": 22,
              "rt": 1,
              "dt": 2,
              "l": 0,
              "h": 0,
              "active_only": true
            },
            {
              "id": 5,
              "da": 2,
              "ra": 88,
              "rt": 1,
              "dt": 2,
              "l": 0,
              "h": 0,
              "active_only": false
            }
          ],
          "units": {
            "da": 2,
            "ra": 88,
            "rt": 1,
            "dt": 2
          },
          "pump_type": parseInt(event.target.value),
          "start_delay": 0,
          "stop_delay": 0
        },
        "schedule": {
          "sun": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          },
          "mon": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          },
          "tue": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          },
          "wed": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          },
          "thu": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          },
          "fri": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          },
          "sat": {
            "automation": 1,
            "start_time": "00:01",
            "stop_time": "23:59",
            "start_time_h": 0,
            "start_time_m": 1,
            "stop_time_h": 23,
            "stop_time_m": 59,
            "no_of_cycles": 1,
            "cycle_gap": 60,
            "cycle_gap_minute": 1,
            "batches": []
          }
        },
        "remove_history": "any value"
      };
      // {
      //   "settings": {
      //     "timezone": 5.5,
      //     "automation": 1,
      //     "start_time_h": 8,
      //     "start_time_m": 0,
      //     "stop_time_h": 23,
      //     "stop_time_m": 0,
      //     "sensing": {
      //       "l12_l": 340,
      //       "l12_h": 450,
      //       "l23_l": 340,
      //       "l23_h": 450,
      //       "l31_l": 340,
      //       "l31_h": 450,
      //       "c_l": 0,
      //       "c_h": 50
      //     },
      //     "pump_type": parseInt(event.target.value),
      //     "start_delay": 0,
      //     "stop_delay": 0,
      //     "otaRequested": false,
      //     "otaStatus": false,
      //     "otaStatusSent": true
      //   },
      //   "schedule": [
      //     {
      //       "sun": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     },
      //     {
      //       "mon": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     },
      //     {
      //       "tue": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     },
      //     {
      //       "wed": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     },
      //     {
      //       "thu": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     },
      //     {
      //       "fri": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     },
      //     {
      //       "sat": {
      //         "v1": 0,
      //         "v2": 0,
      //         "v3": 0,
      //         "v4": 0,
      //         "v5": 0,
      //         "v6": 0
      //       }
      //     }
      //   ]
      // };


    }
    this.setState({
      devices: devices
    })
  }

  handleStartDelay = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.start_delay = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }

  handleStopDelay = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.stop_delay = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }


  handlel12_l = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[0].l = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }
  handlel12_h = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[0].h = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }


  handlel23_l = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[1].l = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }
  handlel23_h = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[1].h = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }

  handlel31_l = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[2].l = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }
  handlel31_h = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[2].h = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }



  handlelc_l = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[3].l = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }
  handlelc_h = (event, index) => {
    var devices = this.state.devices;
    if (devices[index]?.config?.settings) {
      devices[index].config.settings.sensing[3].h = parseInt(event.target.value);
    }
    this.setState({
      devices: devices
    })
  }



  // onTimeChangeStartSun = (time, timeString, index, day) => {
  //   const devices = [...this.state.devices];
  //   devices[index].config.schedule[day].start_time = timeString;
  //   devices[index].config.schedule[day].start_time_h = parseInt(timeString.split(":")[0], 10);
  //   devices[index].config.schedule[day].start_time_m = parseInt(timeString.split(":")[1], 10);

  //   this.setState({
  //     devices: devices
  //   })
  // }

  // onTimeChangeStopSun = (time, timeString, index, day) => {
  //   const devices = [...this.state.devices];
  //   devices[index].config.schedule[day].stop_time = timeString;
  //   devices[index].config.schedule[day].stop_time_h = parseInt(timeString.split(":")[0], 10);
  //   devices[index].config.schedule[day].stop_time_m = parseInt(timeString.split(":")[1], 10);
  //   this.setState({
  //     devices: devices
  //   })
  // }

  onTimeChangeStartSun = (time, timeString, index, day) => {
    const devices = [...this.state.devices];
    const startHour = parseInt(timeString.split(":")[0], 10);
    const startMinute = parseInt(timeString.split(":")[1], 10);

    // Get the previous day's stop_time and start_time
    const prevDay = this.getPrevDay(day);
    const prevStopHour = devices[index].config.schedule[prevDay].stop_time_h;
    const prevStopMinute = devices[index].config.schedule[prevDay].stop_time_m;
    const prevStartHour = devices[index].config.schedule[prevDay].start_time_h;
    const prevStartMinute = devices[index].config.schedule[prevDay].start_time_m;

    // Validate start_time against the previous day's stop_time, but only if the previous day's start > stop
    if ((prevStartHour > prevStopHour || (prevStartHour === prevStopHour && prevStartMinute > prevStopMinute)) &&
      (startHour < prevStopHour || (startHour === prevStopHour && startMinute < prevStopMinute))) {
      alert("Start time cannot be earlier than the previous day's stop time.");
      return;
    }

    // Update start_time for the selected day
    devices[index].config.schedule[day].start_time = timeString;
    devices[index].config.schedule[day].start_time_h = startHour;
    devices[index].config.schedule[day].start_time_m = startMinute;

    this.setState({
      devices: devices
    });
  };

  onTimeChangeStopSun = (time, timeString, index, day) => {
    const devices = [...this.state.devices];
    let stopHour = parseInt(timeString.split(":")[0], 10);
    let stopMinute = parseInt(timeString.split(":")[1], 10);

    // Update stop_time for the selected day
    devices[index].config.schedule[day].stop_time = timeString;
    devices[index].config.schedule[day].stop_time_h = stopHour;
    devices[index].config.schedule[day].stop_time_m = stopMinute;

    // Handle crossing into the next day only if current day's start > stop
    const startHour = devices[index].config.schedule[day].start_time_h;
    const startMinute = devices[index].config.schedule[day].start_time_m;

    if (startHour > stopHour || (startHour === stopHour && startMinute > stopMinute)) {
      const nextDay = this.getNextDay(day);

      // Increment stop_time by 1 minute
      stopMinute += 1;
      if (stopMinute === 60) {
        stopMinute = 0;
        stopHour += 1;
      }
      if (stopHour === 24) {
        stopHour = 0;
      }

      const nextDayStartHour = devices[index].config.schedule[nextDay].start_time_h;
      const nextDayStartMinute = devices[index].config.schedule[nextDay].start_time_m;

      // Adjust next day's start_time if the new stop_time is valid
      if (stopHour > nextDayStartHour || (stopHour === nextDayStartHour && stopMinute > nextDayStartMinute)) {
        const adjustedTimeString = `${stopHour.toString().padStart(2, "0")}:${stopMinute.toString().padStart(2, "0")}`;
        devices[index].config.schedule[nextDay].start_time = adjustedTimeString;
        devices[index].config.schedule[nextDay].start_time_h = stopHour;
        devices[index].config.schedule[nextDay].start_time_m = stopMinute;
      }
    }

    this.setState({
      devices: devices
    });
  };


  // Helper function to get the next day
  getNextDay = (day) => {
    const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    const currentIndex = days.indexOf(day);
    return days[(currentIndex + 1) % days.length];
  };

  // Helper function to get the previous day
  getPrevDay = (day) => {
    const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    const currentIndex = days.indexOf(day);
    return days[(currentIndex - 1 + days.length) % days.length];
  };





  handleChange_copyfrom = (event, index, day) => {
    const value = parseInt(event.target.value, 10); // Parse the value as an integer
    const devices = [...this.state.devices];

    // Map numeric values directly to day strings
    const dayMap = {
      1: "sun",
      2: "mon",
      3: "tue",
      4: "wed",
      5: "thu",
      6: "fri",
      7: "sat",
    };

    const new_day = dayMap[value]; // Get the corresponding day
    if (!new_day) return; // Exit if value is invalid

    const dayIdPrefixes = {
      sun: 100,
      mon: 200,
      tue: 300,
      wed: 400,
      thu: 500,
      fri: 600,
      sat: 700,
    };

    const remapBatchIds = (batches, targetDayPrefix) =>
      (batches || []).map((batch, index) => ({
        ...batch, // Clone the batch object
        id: targetDayPrefix + index + 1, // Assign new ID based on prefix
      }));

    const targetDayPrefix = dayIdPrefixes[day];
    const sourceDayBatches = devices[index].config.schedule[new_day]?.batches || [];

    // Recalculate IDs for the target day and update the schedule
    devices[index].config.schedule[day] = {
      ...devices[index].config.schedule[new_day], // Copy settings from new_day
      batches: remapBatchIds(sourceDayBatches, targetDayPrefix), // Replace batches with updated IDs
      copy_from: value,
    };

    // Update state with the modified devices
    this.setState({ devices });
  };


  handleChange_ops_mode_sun = (event, index, day) => {
    const value = event.target.value; // Parse the value as a float representing hours
    const devices = [...this.state.devices];
    //console.log(day);
    //devices[index].config.schedule[day].automation = value;
    devices[index].config.schedule[day].automation = parseInt(value, 10);
    this.setState({
      devices: devices
    })
  }

  handleChange_noofcycles_sun = (event, index, day) => {
    //const value = event.target.value; // Parse the value as a float representing hours
    const value = parseInt(event.target.value, 10);
    const devices = [...this.state.devices];
    devices[index].config.schedule[day].no_of_cycles = value;
    this.setState({
      devices: devices
    })
  }
  handleCyclegapChangeSun = (event, index, day) => {
    const value = parseFloat(event.target.value); // Ensure value is a number
    if (value <= 0) {
      return;
    }

    //console.log(event);
    //const value = event.target.value; // Parse the value as a float representing hours
    const devices = [...this.state.devices];
    devices[index].config.schedule[day].cycle_gap_minute = value;
    devices[index].config.schedule[day].cycle_gap = value * 60;

    this.setState({
      devices: devices
    })
  }

  handleUpdateSunBatch = (updatedCards, index, day) => {
    const devices = [...this.state.devices];
    devices[index].config.schedule[day].batches = updatedCards;
    this.setState({
      devices: devices
    })
  }






  renderDevicesAnchorDetails = (data, index) => {
    //console.log(data);
    if (data.exp_device_type === 53 || data.exp_device_type === 72) {
      return (
        <Card className="mb-0" key={index}>
          <CardHeader id={"heading" + index}>
            <Button block color="link" className="text-left m-0 p-0" onClick={() => this.toggleAnchorAccordion(index)} aria-expanded={this.state.anchoraccordion[index]} aria-controls={"collapse" + index}>
              <i className="fa fa-caret-square-o-right"></i>
              &nbsp;&nbsp;
              <strong>{this.props.embeddedDevice ? "⚙ Settings" : <React.Fragment>{data.device_name} : {data.exp_device_mac_id}</React.Fragment>}</strong>
              {this.props.embeddedDevice ? "" : " - "}{this.props.embeddedDevice ? "" : (data.user_name
                ? data.user_name
                : data.user_email
                  ? data.user_email
                  : data.user_mobile)}
              <br />
              {data.is_sync == null ? "" : data.is_sync ? this.state.lblExplblmsg087 :
                <div style={{ color: 'red' }}>
                  {this.state.lblExplblmsg086}
                </div>
              }


            </Button>
          </CardHeader>
          <Collapse isOpen={this.state.anchoraccordion[index]} data-parent="#anchoraccordion" id={"collapse" + index} aria-labelledby={"heading" + index}>
            <CardBody>
              {!this.state.IsDeviceLoaded ?
                <a style={{ cursor: "pointer" }} onClick={e => this.fetchDeviceDetails(this.state.farm_id)} className="float-right"><i className="icon-refresh"></i></a>
                : <a className="float-right"><Loader type={"small"} /></a>
              }
              <ExportDeviceSettingsMobileStarter
                data={data}


                uid={this.props.uid}
                farm_id={this.state.farm_id}
                exp_device_mac_id={data.exp_device_mac_id}

                disabled={this.state.disabled}
                isButtonLoading={this.state.isButtonLoading}


                handleMotorType={this.handleMotorType}
                handleValveBrand={this.handleValveBrand}
                handleStartDelay={this.handleStartDelay}
                handleStopDelay={this.handleStopDelay}

                handlel12_l={this.handlel12_l}
                handlel12_h={this.handlel12_h}
                handlel23_l={this.handlel23_l}
                handlel23_h={this.handlel23_h}
                handlel31_l={this.handlel31_l}
                handlel31_h={this.handlel31_h}
                handlelc_l={this.handlelc_l}
                handlelc_h={this.handlelc_h}

                onTimeChangeStartSun={this.onTimeChangeStartSun}
                onTimeChangeStopSun={this.onTimeChangeStopSun}
                handleChange_ops_mode_sun={this.handleChange_ops_mode_sun}
                handleUpdateSunBatch={this.handleUpdateSunBatch}
                handleChange_noofcycles_sun={this.handleChange_noofcycles_sun}
                handleCyclegapChangeSun={this.handleCyclegapChangeSun}
                handleChange_copyfrom={this.handleChange_copyfrom}

                handleCheckboxChangeforce_immediate={this.handleCheckboxChangeforce_immediate}

                btnSubmit={this.btnSubmit}

                index={index}
              />
            </CardBody>
          </Collapse>
        </Card>
      );
    }

    return null; // Handle other cases here if necessary
  }

  render() {
    var backgroundColorForSuccess = { backgroundColor: "green", color: '#ffffff' }
    var backgroundColorForError = { backgroundColor: "red", color: '#ffffff' }
    return (
      <>

        {this.state.errorMessageToast ?
          <div style={{ position: 'absolute', right: 10, width: '315px', zIndex: 1022 }} ref="toastDiv">
            <Toast isOpen={this.state.isOpenToast} className="p-3 my-2 rounded" style={this.state.issuccess ? backgroundColorForSuccess : backgroundColorForError}>
              <ToastBody>
                {this.state.errorMessageToast}
              </ToastBody>
            </Toast>
          </div>
          : ''}
        <div id="deviceanchor1">
          <div id="anchoraccordion">
            {this.state.devices && this.state.devices.length > 0 && this.state.devices.map((data, index) => (
              this.renderDevicesAnchorDetails(data, index)
            ))}
          </div>
        </div>

        <div className="animated fadeIn">
          {this.state.IsDeviceLoaded ? <Loader code="info" /> : null}
        </div>
      </>
    )
  }
}

export default ExportDeviceSettings;
